<template>
  <div v-if="showDialog"
       id="pdfDialog"
       class="pdf-dialog">
    <div class="pdf-headers">
      <div size="mini"
           style="width: calc(100% - 35px);">
        <p class="pdf-headers-p">{{pdfFileName}}</p>
      </div>
      <div @click="closeDialog"
           style="width: 32px;">
        <p class="more-p el-icon-close"></p>
      </div>
    </div>
    <div class="pdf-main"
         ref="scrollContainer"
         @scroll="scrollPage">
      <div style="margin:0 auto"
           :style="{
        width: scale + '%',
        transform: 'rotate(' + pageRotate + 'deg)'
      }">
        <pdf ref="pdf"
             :src="url"
             :page="pageNum"
             :rotate="pageRotate"
             @progress="loadedRatio = $event"
             @page-loaded="pageLoaded($event)"
             @num-pages="pageTotalNum=$event"
             @error="pdfError($event)"
             @link-clicked="page = $event">
        </pdf>
      </div>
    </div>
    <div class="footers">
      <ul class="footer-ul">
        <li class="btnClass"
            :class="{select:idx==0}"
            @touchstart="idx=0"
            @touchend="idx=-1"
            @click="scaleD">
          <p class="more-p el-icon-zoom-in"></p>
        </li>
        <li class="btnClass"
            :class="{select:idx==1}"
            @touchstart="idx=1"
            @touchend="idx=-1"
            @click="scaleX">
          <p class="small-p el-icon-zoom-out"></p>
        </li>
        <li class="btnClass"
            :class="{select:idx==2}"
            @touchstart="idx=2"
            @touchend="idx=-1"
            @click="prePage()"
            id="btnPrePage">
          <p class="up-p el-icon-arrow-left"></p>
        </li>
        <li style="width:120px;">
          <div class="page-p"
               style="margin-top:0px;">
            <div>
              <input v-model.number="curPageNum"
                     size="mini"
                     :height="25"
                     @input="numberChange"
                     onkeypress='return( /[\d]/.test(String.fromCharCode(event.keyCode)))'> / {{pageTotalNum}}
            </div>
          </div>
        </li>
        <li class="btnClass"
            :class="{select:idx==3}"
            @touchstart="idx=3"
            @touchend="idx=-1"
            @click="nextPage()"
            id="btnNextPage">
          <p class="down-p el-icon-arrow-right"></p>
        </li>
        <li class="btnClass"
            :class="{select:idx==4}"
            @touchstart="idx=4"
            @touchend="idx=-1"
            @click="download"
            style="width:120px;max-width:max-content;">
          <div class="down-p el-icon-download"><span>{{$t('report.Download')}}</span></div>
        </li>
        <li class="btnClass"
            :class="{select:idx==5}"
            @touchstart="idx=5"
            @touchend="idx=-1"
            v-if="showSendMail"
            @click="openSendMailDialog"
            style="width:120px;max-width:max-content;">
          <div class="down-p el-icon-message"><span>{{$t('report.SendEmail')}}</span></div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import pdf from 'vue-pdf'
import { Notification } from 'element-ui'
export default {
  props: {
    showDialog: {
      type: Boolean,
      default: false
    },
    url: {
      type: String,
      default: ''
    },
    pdfFileName: {
      type: String,
      default: ''
    },
    showSendMail: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      pageNum: 1,
      pageTotalNum: 1,
      pageRotate: 0,
      // 加载进度
      loadedRatio: 10,
      curPageNum: 1,
      idx: 0,
      scale: 65 // 放大系数
    }
  },
  created () {

  },
  components: {
    pdf
  },
  mounted: function () {
  },
  methods: {
    // 上一页函数，
    prePage () {
      var page = this.pageNum
      this.pageNum = page
      if (this.pageNum > 1) {
        this.pageNum = page - 1
      }
    },
    // 下一页函数
    nextPage () {
      var page = this.pageNum
      if (page < this.pageTotalNum) {
        this.pageNum = page + 1
      }
    },
    // 页面顺时针翻转90度。
    clock () {
      this.pageRotate += 90
    },
    // 页面逆时针翻转90度。
    counterClock () {
      this.pageRotate -= 90
    },
    // 放大
    scaleD () {
      this.scale += 5
    },
    // 缩小
    scaleX () {
      if (this.scale === 20) {
        return
      }
      this.scale -= 5
    },
    // 页面加载回调函数，其中e为当前页数
    pageLoaded (e) {
      this.curPageNum = e
    },
    // 其他的一些回调函数。
    pdfError (error) {
      console.error(error)
      Notification({
        type: 'warning',
        title: 'ERROR',
        message: error,
        duration: 3000,
        showClose: false
      })
    },
    pdfPrintAll () {
      this.$refs.pdf.print()
    },
    closeDialog () {
      this.pageNum = 1
      this.scale = 65
      this.$emit('closeDialog')
    },
    download: function () {
      let link = document.createElement('a')
      link.href = this.url
      link.setAttribute('download', this.pdfFileName)
      document.body.appendChild(link)
      link.click()
    },
    scrollPage () {
      var page = this.pageNum
      let clientHeight = this.$refs.scrollContainer.clientHeight
      let scrollTop = this.$refs.scrollContainer.scrollTop
      let scrollHeight = this.$refs.scrollContainer.scrollHeight
      if (scrollTop + clientHeight === scrollHeight) {
        if (page < this.pageTotalNum) {
          this.pageNum = page + 1
        } else { // 最后一页
          return
        }
        this.$refs.scrollContainer.scrollTop = 10
      }
      if (scrollTop === 0) {
        if (page > 1) {
          this.pageNum = page - 1
        } else { // 首页
          return
        }
        this.$refs.scrollContainer.scrollTop = 10
      }
    },
    openSendMailDialog () {
      this.$parent.openSendMailDialog(this.id, this.pdfFileName)
    },
    numberChange (val, index) {
      if (this.curPageNum === null || this.curPageNum.toString().trim() === '' || this.curPageNum < 1) {
        this.curPageNum = 1
      }
      if (this.curPageNum > this.pageTotalNum) {
        this.pageNum = this.pageTotalNum
        this.curPageNum = this.pageTotalNum
      } else {
        this.pageNum = this.curPageNum
      }
    }
  }
}
</script>

<style scoped lang="scss">
.pdf-dialog {
  position: fixed;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 101;
  background-color: rgba(0, 0, 0, 0.8);
}
.pdf-headers {
  position: fixed;
  top: 2px;
  width: 100%;
  display: flex;
  z-index: 102;
  color: #dcdfe6;
  line-height: 10px;
  height: 30px;
  background-color: #222323;
}

.pdf-headers-p {
  margin-top: 8px;
  font-size: 15px;
  padding-left: 15px;
}

.pdf-main {
  overflow-y: auto;
  height: calc(100vh - 60px);
  margin-top: 30px;
}
.pdf-main::-webkit-scrollbar {
  width: 5px;
  height: 10px;
  background-color: #f5f5f5;
}
.pdf-main::-webkit-scrollbar-track {
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  background-color: #f5f5f5;
}

.pdf-main::-webkit-scrollbar-thumb {
  border-radius: 10px;
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #aaa;
}
.footers {
  position: fixed;
  bottom: 2px;
  width: 100%;
  display: flex;
  z-index: 102;
  color: #dcdfe6;
  line-height: 10px;
  height: 30px;
  background-color: #222323;
}

.footer-ul {
  bottom: 0;
  display: flex;
  margin: 0 auto;
  z-index: 200;
  list-style: none;
  padding-left: 15px;
}

.footer-ul li {
  text-align: center;
  /*   flex: 1; */
  padding: 5px 10px 5px 10px;
  cursor: pointer;
}
.footer-ul li.btnClass:hover {
  background: rgba(255, 255, 255, 0.08);
  border-radius: 4%;
}
.footer-ul li.btnClass {
  max-width: 29px;
}
.more-p {
  margin: 0;
  cursor: pointer;
  font-size: 25px;
}

.small-p {
  margin: 0;
  cursor: pointer;
  font-size: 25px;
}

.up-p {
  margin: 0;
  cursor: pointer;
  font-size: 25px;
}

.down-p {
  margin: 0;
  cursor: pointer;
  font-size: 25px;
  span {
    font-size: 14px;
    float: right;
    margin-top: 5px;
    padding-left: 2px;
    font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB,
      Microsoft YaHei, SimSun, sans-serif;
  }
}
.page-p {
  margin-top: 8px;
  font-size: 18px;
  input {
    width: 30px;
    line-height: inherit;
    background: rgba(0, 0, 0, 0.5);
    border: none;
    color: white;
    font-family: inherit;
    outline: none;
    text-align: center;
  }
}
</style>
